// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.qty-controls[data-v-8755db18] {\n  display: grid; \n  width: 100%; \n  max-width: 100px; \n  grid-template-columns: auto 45px auto; \n  justify-content: flex-end;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
